import React, { memo, useEffect, useMemo, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Pagination, IconButton, Collapse, Box, Typography } from '@mui/material';
import axios from '../../shared/axiosConfig';
import InvestorEarningsForm from './InvestorEarningsForm';
import { InvestorEarnings, InvestorProratedEarnings, PaginatedResponse } from '../../shared/models';
import { SnackbarSeverity, useSnackbar } from '../../shared/services/SnackbarService';
import CurrencyAmount from '../../shared/components/CurrencyAmount';
import DateTimeValue from '../../shared/components/DateTimeValue';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PercentageValue from '../../shared/components/PercentageValue';

interface RowProps  {
    row: any
}

const InvestorEarningsListDetail = (props: RowProps) => {
    const [loading, setLoading] = useState<boolean>(true);
    const { showSnackbar } = useSnackbar();
    
    const [page, setPage] = useState<number>(1);
    const [rowsPerPage] = useState<number>(9); // Number of restaurants per page
    const [totalPages, setTotalPages] = useState<number>();

    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [earningDetails, setEarningDetails] = useState<InvestorProratedEarnings[]>();

    useEffect(() => {
        if (open) {
            if (!earningDetails) {
                fetchEarningDetails()
            }
        }
    }, [open])

    const fetchEarningDetails = async () => {
        try {
            let url = `investor-earnings/${row.id}/earning_details/`;
            setLoading(true);
            const response = await axios.get<PaginatedResponse<InvestorProratedEarnings>>(url, {
                params: {
                    page: page,
                    page_size: rowsPerPage
                }
            });
            setEarningDetails(response.data.results);
            setTotalPages(Math.ceil(response.data.count/rowsPerPage));
        } catch (error) {
            console.error("Failed to fetch restaurants", error);
            showSnackbar("Failed to fetch restaurants. Please try again.", SnackbarSeverity.ERROR);
        } finally {
            setLoading(false);
        }
        
        
    };
      
    return (
          <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
              <TableCell>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
              <TableCell>{row.business.name}</TableCell>
            
            <TableCell><CurrencyAmount amount={row.business_revenue.net_revenue} /></TableCell>
            <TableCell><PercentageValue value={row.avg_ownership} /></TableCell>
            <TableCell><CurrencyAmount amount={row.earning_amount}/> </TableCell>
            <TableCell><DateTimeValue value={row.earning_date} includeTime={true} /></TableCell>
            <TableCell><DateTimeValue value={row.business_revenue.start_date} /> - <DateTimeValue value={row.business_revenue.end_date} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                
                                
                                <TableCell>Start</TableCell>
                                <TableCell>End</TableCell>
                                <TableCell>Prorated Ownership</TableCell>
                                <TableCell>Earnings</TableCell>
                                <TableCell>Period</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {earningDetails && earningDetails.map((earningDetail, iindex) => {
                                return (
                                    <TableRow>
                                        <TableCell>{iindex + 1}</TableCell>
                                        
                                        
                                        <TableCell><DateTimeValue value={earningDetail.start_date} /></TableCell>
                                        <TableCell><DateTimeValue value={earningDetail.end_date} /></TableCell>
                                        <TableCell><PercentageValue value={earningDetail.prorated_ownership} /></TableCell>
                                        <TableCell><CurrencyAmount amount={earningDetail.prorated_earnings} /></TableCell>
                                        <TableCell>{earningDetail.period_days} days</TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                    </div>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        );

};

export default memo(InvestorEarningsListDetail);